export const defaultProperties = {
  animationDuration: 100,
  animationTimingFunction: 'ease-in-out',
  position: 'absolute',
  zIndex: 1000,
  fadeIn: true,
};
